// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2p1vD","textarea":"styles_textarea__1vrqe"};